<button mat-button mat-stroked-button class="edit-button" (click)="onClickEdit()">
  {{ 'PROFILE_PAGE.EDIT' | translateForCrmObject: objectType | async }}
</button>
